import { OrderCancelEffect } from './order-cancel.effect';

export const effects: any[] = [
  OrderCancelEffect,
];
